
import Base from "@/components/pages/valorizations/internal/observatory/BaseInternalChartValorization.vue";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Component } from "vue-property-decorator";

@Component
export default class EvolutionOfFloristicKnowledgeChart extends Base {
  protected title = "Evolution des connaissances floristiques";
  protected subTitle = "Observatoire Flore";
  protected description = "";
  protected url =
    "/valorization/observatory/flora/evolution-of-floristic-knowledge";

  drawData() {
    let vm = this;
    let count = this.data.reduce((prev, cur) => prev + cur["count"], 0);

    this.data = count > 0 ? this.data : [];

    this.chart = am4core.create(this.$refs.chart, am4charts.XYChart);
    // this.chart.hiddenState.properties.opacity = 0;

    this.chart.data = this.data;

    this.chart.exporting.menu = new am4core.ExportMenu();
    this.chart.exporting.filePrefix = this.subTitle + " - " + this.title;

    // Create axes
    const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "year";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;

    categoryAxis.renderer.labels.template.adapter.add("dy", function(
      // @ts-ignore
      dy,
      // @ts-ignore
      target
    ) {
      if (target.dataItem && target.dataItem.index && (2 == 2)) {
        return dy + 25;
      }
      return;
      dy;
    });

    let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

    // Create series
    let series = this.chart.series.push(new am4charts.LineSeries());
    series.name = "Années";
    series.dataFields.valueY = "count";
    series.dataFields.categoryX = "year";

    series.stroke = am4core.color("#30b62d");
    series.strokeWidth = 3;
    // series.propertyFields.strokeDasharray = "lineDash";
    series.tooltip.label.textAlign = "middle";

    let bullet = series.bullets.push(new am4charts.Bullet());
    bullet.fill = am4core.color("#30b62d"); // tooltips grab fill from parent by default
    bullet.tooltipText =
      "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]";
    let circle = bullet.createChild(am4core.Circle);
    circle.radius = 4;
    circle.fill = am4core.color("#fff");
    circle.strokeWidth = 3;
  }
}
